export function toCSV(rows: Record<string, unknown>[]): string {
	if (!rows || rows.length === 0) return "";
	const headers = Object.keys(rows[0]);
	const escape = (val: unknown): string => {
		if (val === null || val === undefined) return "";
		const s = String(val);
		if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
		return s;
	};
	const lines = [headers.join(",")];
	for (const r of rows) {
		lines.push(headers.map((h) => escape(r[h])).join(","));
	}
	return lines.join("\n");
}

export function downloadCSV(filename: string, rows: Record<string, unknown>[]) {
	const csv = toCSV(rows);
	const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
}
